import { Injectable } from '@angular/core';
import { RestService } from '../../shared/service/rest.service';
import { map, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { StoreService } from '../../store/service/store.service';
import { StoreContent } from '../../store/model/store-model';
import { DataLoader } from '../../shared/util/data-loader';
import { Zone } from '../model/zone';
import { Observable } from 'rxjs';
import { classToPlain } from 'class-transformer';
import { RequestCriteria } from '../../shared/model/request-criteria';
import { SortBy } from '../../shared/model/data-source';
import { applyCriteriaAndSorters } from '../../shared/util/data-util';

@Injectable()
export class ZoneService extends RestService implements DataLoader<Zone> {

  readonly storageName = Zone.getName();

  constructor(http: HttpClient, private storeService: StoreService) {
    super(http);
  }

  subscribeData(): void {
    if (!this.storeService.isStorageTypeExists(this.storageName))
      this.storeService.addStorageType(this.storageName, new StoreContent<Zone>((zone: Zone) => zone.id));

    this.postAndExtract<Zone>(Zone, 'api/zones/gwt/fetch', {})
      .pipe(tap(zones => this.storeService.store(this.storageName, zones)))
      .subscribe();
  }

  fetchZones(): Observable<Zone[]> {
    return this.postAndExtract<Zone>(Zone, 'api/zones/gwt/fetch', {});
  }

  saveZone(zone: Zone): Observable<Zone> {
    return this.postAndExtractSingle<Zone>(Zone, 'api/zones/user/gwt/add', {data: zone});
  }

  updateZone(zone: Zone): Observable<Zone> {
    const payload = { data: classToPlain(zone) };
    return this.putAndExtractSingle<Zone>(Zone, 'api/zones/user/gwt/update', payload);
  }

  deleteZone(zone: Zone): Observable<Zone[]> {
    const payload = { data: { zone_id: zone.id } };
    return this.postAndExtract<Zone>(Zone, 'api/zones/user/gwt/remove', payload);
  }

  fetchAll(filters: RequestCriteria, sorters?: SortBy[]): Observable<Zone[]> {
    return this.fetchZones().pipe(map(zones => applyCriteriaAndSorters(zones, filters, sorters)));
  }

  unsubscribeData(): void { }

  getDataType(): any {
    return this.storageName;
  }
}
